import React, { Component } from "react";
import {
  Grid,
  Icon,
  Header,
  Input,
  Button,
  Divider,
  Label,
  Form
} from "semantic-ui-react";
import moment from "moment";
// import InvoiceTable from "./invoicetable";
class CreateInv extends Component {
  constructor(props) {
    let momentdate = moment()
      .endOf("month")
      .subtract(1, "months");
    if (moment(momentdate).isoWeekday() <= 3) {
      momentdate = moment(momentdate).subtract(1, "weeks");
    }
    momentdate = moment(momentdate)
      .endOf("isoWeek")
      .format("YYYY-MM-DD");
    console.log(momentdate);
    super(props);
    this.state = {
      date: momentdate
    };
  }
  componentDidMount() {
    this.props.runinvoices(this.state.date);
  }
  componentDidUpdate(prevProps, prevState) {
    if (!this.props.newinvoices) {
      this.props.runinvoices(this.state.date);
    }
  }
  gencreatebutton() {
    if (this.state.date !== null) {
      return (
        <Button
          color="green"
          id="createinvbtn"
          onClick={() => {
            this.props.createInv();
          }}
        >
          Create Invoices <Icon name="check" />
        </Button>
      );
    }
  }
  gentable() {
    if (this.props.newinvoices && this.props.newinvoices.length === 0) {
      return <Header size="large">Nothing to Invoice for this period</Header>;
    }
  }

  render() {
    return (
      <div className="CreateInv">
        <Grid>
          <Grid.Column width={6}>
            <Form>
              <Form.Group>
                <Form.Field>
                  <Label>Set Date to Run Invoices To</Label>
                  <Input
                    type="date"
                    placeholder="MM/DD/YYYY"
                    value={this.state.date}
                    onChange={e => {
                      let newdate = moment(e.target.value).format("YYYY-MM-DD");
                      this.setState({ date: newdate });
                      this.props.runinvoices(e.target.value);
                    }}
                  />
                </Form.Field>
                <Form.Field>{this.gencreatebutton()}</Form.Field>
              </Form.Group>
            </Form>
          </Grid.Column>
        </Grid>
        <Divider />
        {this.gentable()}
      </div>
    );
  }
}
export default CreateInv;



// WEBPACK FOOTER //
// ./src/components/accounting/invoices/createinvoices.js